import React, { useEffect, useContext, Fragment, useState } from 'react';

//CSS
import '../../../css/components/shared/vehicleCard/VehicleCard.css';

function VehicleCardSkeleton({ }) {

    return (
        <article className="c-card c-card--image c-vehicle-card c-vehicle-card--skeleton u-text-left">
            <div className="c-vehicle-card__carousel-container">
                <div className="">

                </div>
                <span className="c-tag c-tag c-vehicle-card__tag-counter">
                    <span className="c-tag__label"></span>
                </span>
                <span className="c-tag c-tag c-vehicle-card__tag-bid">
                    <span className="c-tag__label"></span>
                </span>
            </div>
            <header className="c-card__header">
                <div className="o-layout">
                    <div className="o-layout__item u-1/1">
                        <p className="c-card__title">
                        </p>
                        <p className="c-card__subtitle">
                        </p>
                    </div>
                </div>
            </header>
            <div className="c-card__body u-pt-none u-pb-none">
                <ul className="c-vehicle-card__options-list">
                    <li> <span></span> </li>
                    <li> <span></span> </li>
                    <li> <span></span> </li>
                    <li> <span></span> </li>
                    <li> <span></span> </li>
                </ul>
                <p className="c-vehicle-card__location">
                    <span className="c-vehicle-card__location-text"></span>
                </p>
            </div>
            <footer className="c-card__footer u-pt-none u-pb-none">
                <div className="c-vehicle-buy-options">
                    <hr />
                    <div className="o-layout">
                        <div className="o-layout__item u-1/3">
                            <p className="c-vehicle-buy-options__bid-price"></p>
                        </div>
                        <div className="o-layout__item u-1/3">
                            <p className="c-vehicle-buy-options__bid-price"></p>
                        </div>
                        <div className="o-layout__item u-1/3 u-pl-none">
                            <div className="c-btn"></div>
                        </div>
                    </div>
                    <div className="o-layout">
                        <div className="o-layout__item u-2/3 u-mt-small u-pr-none">
                            <div className="c-input"></div>
                        </div>
                        <div className="o-layout__item u-1/3 u-mt-small u-pl-none">
                            <div className="c-btn"></div>
                        </div>
                    </div>
                    <hr />
                    <div className="o-layout">
                        <div className="o-layout__item u-1/3 u-pr-none">
                            <p className="c-vehicle-buy-options__bid-price"></p>
                        </div>
                        <div className="o-layout__item u-1/3 u-pr-none">
                        </div>
                        <div className="o-layout__item u-1/3 u-pl-none u-pr-none">
                            <div className="c-btn u-mt-small"></div>
                        </div>
                    </div>
                </div>
            </footer>
        </article>
    )
}

export default VehicleCardSkeleton;
